var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05858 8.63056C6.798 9.9101 7.65022 11.1381 8.75666 12.2579C9.86669 13.3846 11.2471 14.41 13.0338 15.2859C13.1663 15.3477 13.2917 15.3477 13.4045 15.3048C13.5745 15.243 13.7482 15.1073 13.9183 14.9441C14.0508 14.817 14.2155 14.6144 14.3874 14.3928C15.0749 13.5255 15.9253 12.4486 17.1266 12.9879C17.1535 12.9999 17.1732 13.0136 17.2 13.024L21.2069 15.2344C21.2194 15.2413 21.2337 15.2533 21.2445 15.2601C21.7726 15.6088 21.991 16.1464 21.9964 16.7561C21.9964 17.3761 21.7583 18.0734 21.4092 18.6625C20.9473 19.4406 20.2669 19.9558 19.4827 20.2959C18.7362 20.6257 17.9054 20.8026 17.1069 20.9159C15.8537 21.0928 14.6792 20.9795 13.4779 20.6257C12.3034 20.277 11.1199 19.7016 9.8273 18.9356L9.73241 18.8772C9.1398 18.5217 8.49885 18.1421 7.87043 17.6939C5.5716 16.0279 3.22802 13.6216 1.70084 10.9732C0.420726 8.75078 -0.277516 6.35142 0.103831 4.06542C0.315094 2.81163 0.875479 1.67121 1.85302 0.918938C2.70523 0.259414 3.85285 -0.101263 5.33886 0.0258326C5.50894 0.0378551 5.66112 0.132318 5.74169 0.273154L8.31086 4.43983C8.68684 4.907 8.73339 5.37073 8.5275 5.83445C8.35741 6.21402 8.01366 6.56439 7.54459 6.89072C7.40673 7.00408 7.24201 7.11915 7.06835 7.23938C6.49364 7.63956 5.84016 8.10157 6.06395 8.6443L6.05858 8.63056Z",
    fill: "#11998E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b3134160fb15e45124aea6d86431cae3.svg";
export { ForwardRef as ReactComponent };